export const A_SECOND_IN_MS = 1000
export const A_MINUTE_IN_SECONDS = 60
export const TWENTY_MINUTES = 20
export const TWENTY_MINUTES_IN_MS: number = (A_SECOND_IN_MS * A_MINUTE_IN_SECONDS * TWENTY_MINUTES)
export const todayTime = new Date().getTime()
